import type { ItemCategory, ItemDefinition, ItemIconKey } from "@endclock/shared";

const ICONS: Readonly<Record<ItemIconKey, string>> = Object.freeze({
  can: "▣",
  food_bar: "▰",
  bottle: "▥",
  medical: "+",
  metal: "◇",
  fabric: "≋",
  tape: "◉",
  rubber: "◌",
  wire: "∿",
  fastener: "×",
  component: "□",
  battery: "▮",
  circuit: "▦",
  cable: "⌁",
  phone: "▯",
  tool: "⌕",
  misc: "·",
  flashlight: "⌕",
  jeans: "≋",
});

const CATEGORY_FALLBACKS: Readonly<Record<ItemCategory, string>> = Object.freeze({
  FOOD: "▣",
  WATER: "▥",
  MEDICAL: "+",
  MATERIAL: "◇",
  COMPONENT: "□",
  ELECTRONICS: "▦",
  TOOL: "⌕",
  CLOTHING: "≋",
  AMMUNITION: "•",
  WEAPON: "—",
  KEY_ITEM: "⌑",
  MISC: "·",
});

/** One registry, zero per-item image requests, deterministic category fallback. */
export function itemIcon(definition: Readonly<ItemDefinition> | undefined): string {
  if (!definition) return "·";
  return ICONS[definition.iconKey] ?? CATEGORY_FALLBACKS[definition.category];
}
